import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
const b = bemClassBuilder('v-label');
export const LabelSkeleton = () => {
    return _jsx("div", { className: b.block({ skeleton: true }) });
};
